<script setup lang="ts">
const emit = defineEmits(["close"]);
const { createAuthAttemptAndRedirect } = useAuthController();

const openOAuth = (type: string) => {
  const path = addQueryParams(getCurrentFullPath(), { checkout: true });
  createAuthAttemptAndRedirect(type, path);
};
</script>
<template>
  <div>
    <p class="text-neutral-300 font-light">
      {{ $t("main.modalBuyLogin.transactionInstruction") }}
    </p>
    <div class="mt-5 mb-2 sm:mt-6 flex">
      <div class="flex flex-col gap-4">
        <div class="flex items-center gap-4">
          <BaseButtonSubmit
            class="w-44"
            data-test="button-login"
            :contextual-styles="true"
            @click="openOAuth('login')">
            <template #text>
              <span class="text-lg">{{ $t("main.modalBuyLogin.login") }}</span>
            </template>
          </BaseButtonSubmit>
          <BaseButtonCancel
            data-test="button-login-cancel"
            :contextual-styles="true"
            @click="emit('close')">
            <template #text>
              <span class="text-lg">{{ $t("main.modalBuyLogin.cancel") }}</span>
            </template>
          </BaseButtonCancel>
        </div>
        <div class="flex gap-1">
          <p class="text-neutral-200">
            {{ $t("main.modalBuyLogin.notRegisteredYet") }}
          </p>
          <p
            @click="openOAuth('signup')"
            class="text-primary-500 cursor-pointer">
            {{ $t("main.modalBuyLogin.signUp") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
